module.exports = __webpack_public_path__ + "c35fa90ffad2f6f166e4b3d07de3da21.svg";